/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2021-05-06 15:59:13
 *
 *******************************************************/

export const FEATURES_DISPLAY = {
  integrationApp: {
    title: 'AdminHTML.Common.SendRequestFeatureModal.integrationApp_Title',
    userContentLabel: 'AdminHTML.Common.SendRequestFeatureModal.integrationApp_UserContentLabel',
    userContentPlaceholder:
      'AdminHTML.Common.SendRequestFeatureModal.integrationApp_UserContentPlaceholder',
    content:
      'The user theme lib version might not work with app integration yet. Please check user theme version and upgrade to make app integration work. Please get back to them when they need more information.',
    code: 'integrationApp',
    codeDescription: 'Integration app does not work well'
  },
  noSearchResultSuggestion: {
    title: 'AdminHTML.Common.SendRequestFeatureModal.noSearchResultSuggestion_Title',
    userContentLabel:
      'AdminHTML.Common.SendRequestFeatureModal.noSearchResultSuggestion_UserContentLabel',
    userContentPlaceholder:
      'AdminHTML.Common.SendRequestFeatureModal.noSearchResultSuggestion_UserContentPlaceholder',
    content:
      'The user theme lib version might not work with No search result suggestion yet. Please check user theme version and upgrade to make No search result suggestion work. Please get back to them when they need more information.',
    code: 'noSearchResultSuggestion',
    codeDescription: 'No search result suggestion does not work well'
  },
  swatchSettings: {
    title: 'AdminHTML.Common.SendRequestFeatureModal.swatchSettings_Title',
    userContentLabel: 'AdminHTML.Common.SendRequestFeatureModal.swatchSettings_UserContentLabel',
    userContentPlaceholder:
      'AdminHTML.Common.SendRequestFeatureModal.swatchSettings_UserContentPlaceholder',
    content:
      'The user theme lib version might not work with Swatch settings yet. Please check user theme version and upgrade to make Swatch settings work. Please get back to them when they need more information.',
    code: 'swatchSettings',
    codeDescription: 'Swatch settings does not work well'
  },
  searchPageDisplay: {
    title: 'AdminHTML.Common.SendRequestFeatureModal.searchPageDisplay_Title',
    userContentLabel: 'AdminHTML.Common.SendRequestFeatureModal.searchPageDisplay_UserContentLabel',
    userContentPlaceholder:
      'AdminHTML.Common.SendRequestFeatureModal.searchPageDisplay_UserContentPlaceholder',
    content:
      'The user theme lib version might not work with search page display yet. Please check user theme version and upgrade to make Search page display work. Please get back to them when they need more information.',
    code: 'searchPageDisplay',
    codeDescription: 'Search page display does not work well'
  },
  sortByOptions: {
    title: 'AdminHTML.Common.SendRequestFeatureModal.sortByOptions_Title',
    userContentLabel: 'AdminHTML.Common.SendRequestFeatureModal.sortByOptions_UserContentLabel',
    userContentPlaceholder:
      'AdminHTML.Common.SendRequestFeatureModal.sortByOptions_UserContentPlaceholder',
    content:
      'The user theme lib version might not work with Manage sort by options yet. Please check user theme version and upgrade to make Manage sort by options work. Please get back to them when they need more information.',
    code: 'sortByOptions',
    codeDescription: 'Sort by options does not work well'
  },
  filterSettings: {
    title: 'AdminHTML.Common.SendRequestFeatureModal.filterSettings_Title',
    userContentLabel: 'AdminHTML.Common.SendRequestFeatureModal.filterSettings_UserContentLabel',
    userContentPlaceholder:
      'AdminHTML.Common.SendRequestFeatureModal.filterSettings_UserContentPlaceholder',
    content:
      'The user theme lib version might not work with Filter settings yet. Please check user theme version and upgrade to make Filter settings work. Please get back to them when they need more information.',
    code: 'filterSettings',
    codeDescription: 'Filter settings does not work well'
  },
  themeUpgrade: {
    title: 'AdminHTML.Common.SendRequestFeatureModal.themeUpgrade_Title',
    userContentLabel: 'AdminHTML.Common.SendRequestFeatureModal.themeUpgrade_UserContentLabel',
    userContentPlaceholder:
      'AdminHTML.Common.SendRequestFeatureModal.themeUpgrade_UserContentPlaceholder',
    content:
      'User detected some error with their upgraded theme preview. Please check and get back to them when they need more information.',
    code: 'themeUpgrade',
    codeDescription: 'Theme upgrade does not work well'
  },
  filterOptions: {
    title: 'AdminHTML.Common.SendRequestFeatureModal.filterOptions_Title',
    userContentLabel: 'AdminHTML.Common.SendRequestFeatureModal.filterOptions_UserContentLabel',
    userContentPlaceholder:
      'AdminHTML.Common.SendRequestFeatureModal.filterOptions_UserContentPlaceholder',
    content:
      'User detected some error with their filter options. Please check and get back to them when they need more information.',
    code: 'filterOptions',
    codeDescription: 'Filter options does not work well'
  },
  quickViewCartSettings: {
    title: 'AdminHTML.Common.SendRequestFeatureModal.quickViewCartSettings_Title',
    userContentLabel:
      'AdminHTML.Common.SendRequestFeatureModal.quickViewCartSettings_UserContentLabel',
    userContentPlaceholder:
      'AdminHTML.Common.SendRequestFeatureModal.quickViewCartSettings_UserContentPlaceholder',
    content:
      'User detected some error with their quick view and cart settings. Please check and get back to them when they need more information.',
    code: 'quickViewCartSettings',
    codeDescription: 'Quick view and cart settings does not work well'
  },
  filterLayout: {
    title: 'AdminHTML.Common.SendRequestFeatureModal.filterLayout_Title',
    userContentLabel: 'AdminHTML.Common.SendRequestFeatureModal.filterLayout_UserContentLabel',
    userContentPlaceholder:
      'AdminHTML.Common.SendRequestFeatureModal.filterLayout_UserContentPlaceholder',
    content:
      'The user theme lib version might not work with Filter layout yet. Please check user theme version and upgrade to make Filter settings work. Please get back to them when they need more information.',
    code: 'filterLayout',
    codeDescription: 'Filter layout does not work well'
  }
};
